<template>
  <div class="container">
    <Header status="simple" />
    <div @click="$router.go(-1)" class="btn-icon back-btn">
      <div><img src="../assets/back.png" /></div>
      <div>返回</div>
    </div>
    <MapTitle :data="mapTitleData" @getCurTab="setCurtab"/>
    <div>
      <Heatmap
        :title="heatmapData.title"
        :heatmapData="heatmapData.heatmapData"
        v-if="heatmapData"
      />
      <div class="right-content">
        <BScroll
          ><div>
            <BasePanel title="游客实时监控情况">
              <YoukeShishiJiankongQingkuang
                :chartData="YoukeShishiData.people_inside"
                v-if="YoukeShishiData"
              />
              <p>&nbsp;</p>
            </BasePanel>
            <BasePanel title="游客来源分析">
              <YoukeLaiyuanFenxi
                :chartData="YoukeShishiData.come_from"
                v-if="YoukeShishiData"
              />
              <p>&nbsp;</p>
            </BasePanel>
            <BasePanel title="游客群体画像及行为解析">
              <YoukeQuntiHuaxiangXingweiJiexi />
            </BasePanel></div
        ></BScroll>
      </div>
      <div class="spot-bottom-line">
        <SpotBottomLine :chartData="blData" v-if="blData" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Common/Header.vue";
import BScroll from "@/components/Common/BScroll.vue";
import BasePanel from "@/components/Common/BasePanel.vue";
import Heatmap from "@/components/Loca/Heatmap.vue";
import YoukeLaiyuanFenxi from "@/components/SpotRealtime/YoukeLaiyuanFenxi.vue";
import YoukeQuntiHuaxiangXingweiJiexi from "@/components/SpotRealtime/YoukeQuntiHuaxiangXingweiJiexi.vue";
import YoukeShishiJiankongQingkuang from "@/components/SpotRealtime/YoukeShishiJiankongQingkuang.vue";
import SpotBottomLine from "@/components/Echarts/SpotBottomLine.vue";
import MapTitle from '@/components/Common/MapTitle.vue'

export default {
  name: "SpotRealtime",
  components: {
    Header,
    BasePanel,
    BScroll,
    Heatmap,
    YoukeLaiyuanFenxi,
    YoukeQuntiHuaxiangXingweiJiexi,
    YoukeShishiJiankongQingkuang,
    SpotBottomLine,
    MapTitle
  },
  data() {
    return {
      heatmapData: null,
      YoukeShishiData: null,
      blData: null,
      mapTitleData: {
        title: '',
        tab: ['实时', '历史']
      },
    };
  },
  mounted() {
    // 请求热图
    fetch("/data/SpotRealtime/Heatmap.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.heatmapData = json.data;
      });
    // 请求实时监控
    fetch("/data/SpotRealtime/YoukeShishi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.YoukeShishiData = json.data;
      });
    // 请求线条图表
    fetch("/data/SpotRealtime/SpotBottomLine.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.blData = json.data;
      });
  },
  methods: {
    setCurtab(val) {
      if(val == 1) {
        this.$router.push({path: '/spotpasttime'})
      }
    }
  }
};
</script>
<style scoped lang="less">
.container {
  .map-title {
    width: 3rem;
    left: 5rem;
    top: 0.05rem;
    position: absolute;
    z-index: 10010;
  }
  .right-content {
    top: 0.64rem;
  }
  .back-btn {
    left: 0.6rem;
    top: 0.8rem;
  }
  .spot-bottom-line {
    width: 76%;
    height: 30%;
    position: absolute;
    left: 0;
    bottom: 0.2rem;
  }
}
</style>
